module.exports = __webpack_public_path__ + "img/off_inspector_vacias.676755eb.png";